"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransformSchematicDrawing = void 0;
const _ = require("lodash");
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const TransformObject_1 = require("./TransformObject");
class TransformSchematicDrawing extends TransformObject_1.TransformObject {
    constructor(parent, data, netRefObject) {
        const serialized = JSON.stringify(sigma_engine_shared_1.Utils.sortObjectKeysRecursively(_.omit(data, 'net', 'nets')));
        super(parent, { data, netRefObject }, `drawing::${serialized}`, new Set());
        if (netRefObject) {
            if (data.drawing.type === 'schref') {
                throw new Error('Cannot add net ref object to schref drawing');
            }
            this._sharedData.netRefObject = netRefObject;
        }
    }
    get dependencies() {
        return this._sharedData.netRefObject ? [this._sharedData.netRefObject] : [];
    }
    compile() {
        const compilationResult = this._sharedData.data;
        if (this._sharedData.netRefObject) {
            const drawing = compilationResult.drawing;
            if (drawing.type === 'schref') {
                throw new Error('Cannot add net ref object to schref drawing');
            }
            drawing.net = this._sharedData.netRefObject.compiled.strCast();
        }
        this._sharedData.compiled = compilationResult;
        return this._sharedData.compiled;
    }
}
exports.TransformSchematicDrawing = TransformSchematicDrawing;
//# sourceMappingURL=TransformSchematicDrawing.js.map